const comments = [
  {
    id: 1,
    name: '漫画迷小陈',
    avatar: '陈',
    rating: 5,
    comic: '《剑与魔法》',
    content: '用了YY漫画三年了，下拉式阅读是最舒服的！追更速度也很快，韩漫日漫基本同步更新，画质高清，强烈推荐给所有漫画爱好者。',
    time: '2小时前',
  },
  {
    id: 2,
    name: '二次元学姐',
    avatar: '学',
    rating: 5,
    comic: '《甜蜜陷阱》',
    content: '翻页阅读模式太有感觉了，就像真的在翻纸质漫画书！弹窗模式在地铁上看也特别方便，YY漫画真的懂读者需要什么。',
    time: '5小时前',
  },
  {
    id: 3,
    name: '夜读星人',
    avatar: '夜',
    rating: 5,
    comic: '《暗夜追踪者》',
    content: '夜里看漫画的好伙伴，夜间模式护眼又清晰。韩漫的画风真的太精致了，YY漫画的资源库也很全，找了好久的老番这里都有。',
    time: '8小时前',
  },
  {
    id: 4,
    name: '追更狂魔',
    avatar: '追',
    rating: 4,
    comic: '《命运轮回》',
    content: '每天必刷的漫画平台，更新提醒很及时。三种阅读模式随意切换太贴心了，不同的漫画适合不同的阅读方式，体验拉满。',
    time: '1天前',
  },
  {
    id: 5,
    name: '漫评达人',
    avatar: '漫',
    rating: 5,
    comic: '《星空物语》',
    content: '作为资深漫友，YY漫画的阅读器功能真的很全面。高清显示让画师的每一笔线条都清晰可见，收藏和追更功能也特别好用。',
    time: '1天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-22 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            读者热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            来看看漫画爱好者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-colors"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 font-bold text-sm flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="min-w-0">
                  <div className="font-bold text-sm text-foreground-900 whitespace-nowrap">{comment.name}</div>
                  <div className="text-xs text-foreground-500 whitespace-nowrap">{comment.time}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5 flex-shrink-0">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-amber-400"></i>
                  ))}
                </div>
              </div>
              <div className="inline-block px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
                {comment.comic}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}